<template>
	<span>
		<div class="row row-wrap">
      <!-- rem ellipsis -->
      <a :id="item.sid" class="col-xs-12 aItem row sideless" style="margin: 0px;" @click.prevent="item_clicked(item)">


      <div class="icon-text-container" :class="{'active-tree-item': (item.sid == $root.active_tree_item.id && ($route.query.p == item.idp || $route.query.p == null ) )}">
        <span style="padding: 0px;">
          <div class="sideless side-branch"
          v-if="!isFirstSon"
          :class="{'last': ind == $parent.leaves.length - 1}"> 
            <div class="branch top"></div>
            <div class="branch bot"></div>
          </div>
          <i :class="icons.file"></i>
        </span>
        
        <div v-if="loading" class="custom_spinner" style="margin: 0px -3px 0px 3px;"></div>
        <div class="hide-collapse">
        <span v-if="configs.showId">{{item.sid + " - " }}</span>{{item.des}}</div>
      </div>
      </a>
       
    </div>
      
	</span>
</template>

<script>
import { eventBus } from "../../eventbus";

export default {
  name: "recursive-item",
  props: {
    item: Object,
    ind: Number,
    configs: Object,
    executeOnOpen: String,
    navigationPendingPromise: Object
  },
  mounted: function() {
    if (this.$parent.$el.id == "" || !this.$parent.$el.id) {
      this.heir = 0;
    } else {
      this.heir = parseInt(this.$parent.$el.id) + 1;
    }
    this.am_i_leaf = false;
    if(this.executeOnOpen != null){
      var expandCmd = this.executeOnOpen.split("$");
      if(expandCmd.length > 1 && expandCmd[0] == "expand"){
        this.expand(JSON.parse(expandCmd[1]),Number(expandCmd[2]), expandCmd[3], this.navigationPendingPromise)
      } else {
        this[this.executeOnOpen]()
      }
    }
  },
  created: function(){
    var vm = this;
    eventBus.$on('document_loaded', function(){
      vm.loading = false;
    })
  },
  beforeDestroy: function () {
    this.children = null;
    this.icons = null;
  },
  data: function() {
    var vm = this;
    return {
      children: [],
      icons: {
        dir: vm.$root.icons.dir,
        leaf: vm.$root.icons.child, 
        arrow_right: vm.$root.icons.right,
        arrow_down: vm.$root.icons.down
      },

      stillDown: false,
      showDetail: false,
      heir: 0,

      am_i_leaf: false,
      light_expanded: false,
      loading: false
    };
  },
  computed: {
    isFirstSon: function() {
      return this.$parent.children == null;
    }
  },
  methods: {
    toggleOnSon: function(functionName, index){
      this.children[index].triggered = true;
      this.children[index].execonopen = functionName; 
      this.$forceUpdate();
    },
    item_clicked: function(doc) {
      var vm = this;
      vm.loading = true;
      this.expand();
      eventBus.$emit("closeSidebarDocumenti")
      eventBus.$emit("loadingDocument")
      setTimeout(function(){
        //caricamento diretto del documento nel viewer 
        try{
          var d = doc.doc[0];
          var fname =  d.na.split(".");
          d.ext = fname.pop();
          d.filename = fname.join(".");
          if(d.np){
              d.preview = vm.getPage(d.filename, 1, d.np) + "_tn.jpg";
          }
          eventBus.$emit("changeView", "ImgLayout")
          vm.$nextTick(function(){
              vm.$nextTick(function(){
                  vm.reading = d;
                  //this.elabPreviews();
                  eventBus.$emit("read_pdf", {d:d, from: 'rec-list-doc'})
              })
          })
        }catch(e){
          console.log(e)
          eventBus.$emit("alert", {type: "warning", message: vm.$Jed.firstUpperTranslate("missing document")});
          vm.loading = false;
        }
      }, 100);      
    },
    getFigure4: function(n){
      n = n.toString();
      var figures = n.length;
      var res = "";
      for(var i = 0; i < 4-figures; i++){
          res += "0"
      }
      res += n;
      return res;
    },
    getPage: function(name, npage, ntot){
      return name + "_p" + this.getFigure4(npage) + "-" + this.getFigure4(ntot);
    },





    expand: function(path, step, focus, nav_promise) {
      //path e step undefined, a meno che la chiamata non arrivi dal padre (navigazione diretta)
      this.closeDetail();
      //se sono un nodo foglia, e sono già espanso, non eseguo nulla
     
      if (this.item.cco != 0) {
        //eseguo richiesta se l'elemento è passato da compresso a espanso, oppure anche se era già parzialmente espanso da lightQuery, oppure se è un nodo foglia
       
        this.item.opened = (!this.item.opened || this.light_expanded || this.item.gco == null);
        if (this.item.opened) {
          //trigger timeout per mostrare spinner di caricamento
          this.trigger();
          this.queryThis(this.item.sid, this.item.fid, path, step, focus, nav_promise);
        } else {
          this.children = [];
        }
        //in ogni caso, in seguito il flag light expanded passa a false
        this.light_expanded = false;
      }
    },
    /* arrow_clicked: function(){
      //replico la procedura di expand, con le differenze seguenti:
      this.closeDetail();
      if(this.item.cco != 0){
        this.item.opened = !this.item.opened;
        if(this.item.opened){
          // 1ª il flag light_expanded passa a true prima di chiamare lightQueryThis
          this.light_expanded = true;
          this.trigger();
        } else {
          this.light_expanded = false;
          this.children = [];
        }
      }
    }, */
    trigger: function(){
      var vm = this;
      setTimeout(function(){
        /* if(vm.children && vm.children.length == 0 && !vm.am_i_leaf){ */
          vm.loading = true;
        //}
      },1);
    },
    queryThis: function(id, fid, path, step, focus, nav_promise) {
      var vm = this;
      this.$root
        .microservice({
          role: "catalog",
          cmd: "SearchByFather",
          params: {
            fid: id,
            // aggiunto gfid nelle searchByFather che richiedono info sul padre (meta: true), così posso identificare univocamente il nodo, e non cercare per "sid": fid ottenendo un primo res casuale
            gfid: fid,
            labels: "all",
            leaves: true,
            prod_info: ["att", "not", "gra", "typ", "spi", "doc", "mqt","iti"],
            meta: true,
            meta_prod_info: ["gra", "typ", "def","iti"],
            saleability: true
          }
        })
        .then(
          response => {
            var res = response.body;
            try {
              res = JSON.parse(response.body);
            } catch (err) {}

            this.children = [];
            if (res.children) {
              for (var i = 0; i < res.children.length; i++) {
                var obj = res.children[i];
                if(!obj.lin){
                    obj.opened = false;
                    obj.triggered = false;
                    obj.execonopen = null;
                    obj.nav_promise = null;

                    this.children.push(obj);
                }
              }
             
              if (path != null && step != null) {
                var extract;
                try {
                  extract = path[step + 1].id;
                } catch (err) {
                  console.log(err)
                }
                if (extract == null || extract == "") {
                  this.changeRoute(res, focus, {"path": path, "step": step, "nav_promise": nav_promise});
                  //quando sto eseguendo una navigazione diretta, commit active item solo all'ultimo step della procedura
                 
                } else {
                  this.$nextTick(function() {
                    this.direct(path, step, focus, nav_promise);
                  });
                  this.loading = false;
                }
                
              } else {
                this.changeRoute(res); 
              }
            } else {
              this.loading = false;
            }

            if (this.children.length == 0) {
              this.am_i_leaf = true;
            }

            this.leaves = []
            if(res.leaves){
              for (var i = 0; i < res.leaves.length; i++) {
                var obj = res.leaves[i];
                if(obj.typ == 'Articoli di stampa'){
                  this.leaves.push(obj);
                }
              }
            }
          },
          err => {
            this.loading = false;
            console.log('recursive-list-document - queryThis')
            console.log(err)
            //vedi gestione errore in main.js > microservice
          }
        )
        .catch(err => {
            console.log(err);
            var msg = err && err.body && err.body.error ? err.body.error : ''
            eventBus.$emit('alert', {
              message: "Application caught an error <br> <h5>Details: " + "catalog.SearchByFather - " + msg +'</h5>',
              type: "error",
              action: ''
            })
        });
    },
    changeRoute: function(res, focus, nextParams) {
      var vm = this;
      new Promise(function(resolve,reject){
        //propago un evento verso i genitori dell'elemento attivo, in modo da ricostruire a ritroso il percorso UNIVOCO dell'elemento
        //la promise verrà risolta solo in SidebarMenu, quando la propagazione avrà raggiunto il nodo radice
        vm.$emit("shrimp_build_path", {"path": [], "resolve": resolve, "reject": reject})
      }).then((makeshiftPath) => {
        // console.log("RESOLVED MAKESHIFT PATH")
        // console.log(makeshiftPath);
        /* ------------- prints info */
        //makeshiftPath format [{id: "Root", des: "RADICE"}, {id: "1", des: "UNO"}, ...]
        //il formato è quello usato dal breadcrumb, ma il percorso da tracciare come query di vue-router deve essere mappato a stringa di id...
        //PATH Serial ID
        var SID_PATH = makeshiftPath.map(function(step){
          return step.id;
        }).join("?")
        // inizializzo idp (per ora ha il solo scopo di identificare l'elemento attivo)
        vm.item["idp"] = SID_PATH;

        //AGGIORNA E NOTIFICA NODEWRAPPER E FIGLI
        //emetto evento "è stato cliccato un nodo"
        //l'evento setta in NodeWrapper "ignoreIdle" a true, per fargli intendere che il cambiamento di route.params è causato da una navigazione già avvenuta (non da back del browser)
        //eventBus.$emit("node_clicked");
        //metto l'id del nodo cliccato come parametro dell'url a cui navigare
        /* if(focus != null && focus != "undefined"){
          this.$router.push({
            name: "wrapper_focus",
            params: {
              id:  this.$root.encode(this.item.sid),
              focus: focus
            },
            query: {
              p: SID_PATH
            }
          })
        } else {
          this.$router.push({
            name: "wrapper",
            params: {
              id:  this.$root.encode(this.item.sid)
            },
            query: {
              p: SID_PATH
            }
          });
        } */
        //aggiorno lo store condiviso con il riferimento all'elemento attivo
        this.$store.commit("setActive", {
          father: res.answer,
          children: res.children,
          leaves: res.leaves
        });
        /* //segnalo alla view e sub-view di dettaglio di refreshare i contenuti
        eventBus.$emit("detail_changed");

        //AGGIONRA E NOTIFICA BREADCRUMB
        if (res.answer) {
          var answer = res.answer;
          var active_item = { 
            id: answer.sid, 
            des: answer.des, 
            typ: answer.typ,
            spe: answer.spe, 
            pos: answer.pos,
            fid: answer.fid,
            qty: answer.qty,
            spi: answer.spi,
            not: answer.not
          };
          if (this.$root.active_tree_item != active_item) {
            this.$root.active_tree_item = active_item;
            this.$root.active_tree_path = makeshiftPath;
            eventBus.$emit("active_changed");
          }
        }

        if(nextParams){
          // nextParams è valorizzato solo se è in corso una navigazione diretta, anche questa logica la implemento a fine promise
          this.$nextTick(function() {
            this.direct(nextParams.path, nextParams.step, focus, nextParams.nav_promise);
          });
        } */
        //this.loading = false;
      }, (err) => {
        console.log("MAKE PATH PROMISE REJECTED")
        console.log(err)
      })
      //END THEN
    },
    ShrimpBuildPath: function(e){
      e.path.unshift({'id': this.item.sid, 'des': this.item.des})
      //propago l'evento per costruire il path a ritroso, fino alla radice in SidebarMenu
      this.$emit("shrimp_build_path", {"path": e.path, "resolve": e.resolve, "reject": e.reject})
    },
    activeChanged: function(id, answer) {
      var active_item = { 
        id: id, 
        des: answer.des, 
        path: answer.idp,
        typ: answer.typ,
        spe: answer.spe, 
        pos: answer.pos,
        fid: answer.fid,
        qty: answer.qty,
        spi: answer.spi,
        not: answer.not
      };
      if (this.$root.active_tree_item != active_item) {
        this.$root.active_tree_item = active_item;
        this.$root.active_tree_path = answer.path;
        eventBus.$emit("active_changed");
      }
    },
    direct: function(path, step, focus, nav_promise) {
      step++;
      var extract;
      try {
        extract = path[step].id;
      } catch (err) {}
      //controllo inverso (prima di chiamare questa func controllo che extract sia nullo, e nel caso navigo alla vista dettaglio)
      //qui controllo che esista e continuo la ricerca nell'albero
      if (extract != null && extract != "") {
        var found = false;
        //cerco fra quelli triggered almeno una volta (nei casi pessimi sono molti di meno di quelli mai aperti)
        for (var i = 0; i < this.$children.length; i++) {
          if (this.$children[i].item != null) {
            if (this.$children[i].item.sid == extract) {
              this.$children[i].expand(path, step, focus, nav_promise);
              found = true;
              break;
            }
          }
        }
        if(!found){
          //altrimenti cerco fra i figli non ancora triggherati
          for (var i = 0; i < this.children.length; i++) {
            if (this.children[i].sid == extract) {
              found = true;
              this.children[i].triggered = true; 
              this.children[i].execonopen = "expand$"+JSON.stringify(path)+"$"+step+"$"+focus;
              this.children[i].nav_promise = nav_promise;
              this.$forceUpdate();
              break;
            }
          }
        }
        if(!found){
          nav_promise.reject();
        }
      } else {
        eventBus.$emit("end_nav", this.item.sid, nav_promise);
      }
    },
    // -- METODI PER VISUALIZZAZIONE DETTAGLIO --
    toggle: function() {
      this.showDetail = !this.showDetail;
    },
    closeDetail: function() {
      this.showDetail = false;
    },
    getStartValidity: function(item) {
      if (this.$Behaviors.updatesReference == "date") {
        return this.getDate(item.div);
      } else {
        return item.miv;
      }
    },
    getEndValidity: function(item) {
      if (this.$Behaviors.updatesReference == "date") {
        return this.getDate(item.dfv);
      } else {
        return item.mfv;
      }
    },
    getDate: function(d) {
      try {
        var obj = new Date(d);
        return obj.toLocaleDateString();
      } catch (err) {
        console.log("Err parsing ISO Date");
        console.log(err);
        return d;
      }
    },
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/tree/recursive-list-document.vue?f6200ac4